export enum AvatarSize {
  Default = 'default',
  Large = 'large',
  ExtraLarge = 'extra-large',
}
